import { ServerSideBlock } from '../';

export default class LastPost extends ServerSideBlock {}
